const types = {
  //Get Template name
  GET_CUSTOM_REPORT_START: "GET_CUSTOM_REPORT_START",
  GET_CUSTOM_REPORT_SUCCESS: "GET_CUSTOM_REPORT_SUCCESS",
  GET_CUSTOM_REPORT_ERROR: "GET_CUSTOM_REPORT_ERROR",
  GET_CUSTOM_REPORT_RESET: "GET_CUSTOM_REPORT_RESET",

  //Create Template name
  CREATE_CUSTOM_REPORT_START: "CREATE_CUSTOM_REPORT_START",
  CREATE_CUSTOM_REPORT_SUCCESS: "CREATE_CUSTOM_REPORT_SUCCESS",
  CREATE_CUSTOM_REPORT_ERROR: "CREATE_CUSTOM_REPORT_ERROR",
  CREATE_CUSTOM_REPORT_RESET: "CREATE_CUSTOM_REPORT_RESET",

  //delete Template name
  DELETE_CUSTOM_REPORT_START: "DELETE_CUSTOM_REPORT_START",
  DELETE_CUSTOM_REPORT_SUCCESS: "DELETE_CUSTOM_REPORT_SUCCESS",
  DELETE_CUSTOM_REPORT_ERROR: "DELETE_CUSTOM_REPORT_ERROR",
  DELETE_CUSTOM_REPORT_RESET: "DELETE_CUSTOM_REPORT_RESET",

  //update Template name
  UPDATE_CUSTOM_REPORT_START: "UPDATE_CUSTOM_REPORT_START",
  UPDATE_CUSTOM_REPORT_SUCCESS: "UPDATE_CUSTOM_REPORT_SUCCESS",
  UPDATE_CUSTOM_REPORT_ERROR: "UPDATE_CUSTOM_REPORT_ERROR",
  UPDATE_CUSTOM_REPORT_RESET: "UPDATE_CUSTOM_REPORT_RESET",

  //single item  name
  SINGLE_CUSTOM_REPORT_START: "SINGLE_CUSTOM_REPORT_START",
  SINGLE_CUSTOM_REPORT_SUCCESS: "SINGLE_CUSTOM_REPORT_SUCCESS",
  SINGLE_CUSTOM_REPORT_ERROR: "SINGLE_CUSTOM_REPORT_ERROR",
  SINGLE_CUSTOM_REPORT_RESET: "SINGLE_CUSTOM_REPORT_RESET",
};

export default types;
